import React from "react";

export default function SummaryCard({ icon, title, total, items = [] }) {
  return (
    <div className="col-12 bg-light py-3 mt-3">
      {/* HEADER */}

      <div className="d-flex align-items-center justify-content-between">
        <div className="col text-start listAllItem ms-3">
          <i className={icon + " me-2"} /> {title}
        </div>

        <div className="col text-end">
          <input
            type="text"
            className="me-3 allShowCapital"
            readOnly
            value={total}
          />
        </div>
      </div>

      {/* ITEMS */}

      <div className="row mt-3 ps-3 pe-3">
        {items.map((item, index) => (
          <div key={index} className="col-12 col-md-4">
            <label className="capital-label">{item.label}</label>

            <input
              type="text"
              className="form-control bg-dark text-light"
              readOnly
              value={item.value}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
